import React from 'react'
import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'

import { PageContainer, DesktopPageHeader } from 'components/ResponsiveLayout'
import InfoTerkiniDetailApp from 'app/InfoTerkiniDetailPage/pages/InfoTerkiniDetail'
import { usePemberitahuanDesktopView } from './hooks/usePemberitahuanDesktopView'
import BottomNav from 'app/RuangGTKHomepageV3/components/BottomNav'
import NavigationBar from 'app/Homepage/components/NavigationBar'
import Header from 'app/Homepage/components/Header'
import InfoTerkiniListGroup from './InfoTerkiniListGroup'
import { useSETrackerEvent } from './hooks/useSETrackEvent'
import { consumeInformationPageNavigationOrigin } from './utils/navigationOrigin'

const InfoTerkini = ({ isRuangGtkEnabled, isRuangGtkV3Enabled }) => {
  const router = useRouter()
  const { isDesktop } = usePemberitahuanDesktopView()
  const { selectedId } = router.query
  const tracker = useSETrackerEvent()
  const hasTrackedOpenPage = React.useRef(false)

  React.useEffect(() => {
    if (hasTrackedOpenPage.current) return

    hasTrackedOpenPage.current = true
    tracker.SETrackOpenInformationPage(consumeInformationPageNavigationOrigin())
  }, [tracker])

  const handleSelectId = (id: string) => {
    router.replace(
      {
        pathname: router.pathname,
        query: { ...router.query, selectedId: id },
      },
      undefined,
      { shallow: true }
    )
  }

  if (isDesktop) {
    return (
      <div className="flex flex-col h-screen">
        <DesktopPageHeader
          breadcrumbItems={[{ label: 'Pemberitahuan', href: null }]}
        />
        <div className="flex-1 min-h-0 overflow-hidden bg-surface-subdued">
          <PageContainer className="flex h-full !py-0">
            <aside
              id="desktop-split-left-panel"
              className="w-[38%] min-w-0 border-r border-gray-200 overflow-y-auto flex flex-col bg-white"
            >
              <div className="flex flex-col p-4 space-y-2 bg-white">
                <Text variant="heading-lg" className="line-clamp-2">
                  Pemberitahuan
                </Text>
                <Text className="line-clamp-2" variant="helper">
                  Berita dan update terbaru seputar platform Ruang Guru dan
                  Tenaga Kependidikan (RGTK).
                </Text>
              </div>
              <div className="flex-1 bg-white">
                <InfoTerkiniListGroup
                  isDesktop={isDesktop}
                  selectedId={selectedId}
                  onSelectItem={handleSelectId}
                  scrollableTarget="desktop-split-left-panel"
                />
              </div>
            </aside>

            <main className="flex-1 min-w-0 overflow-y-auto bg-white">
              {selectedId ? (
                <InfoTerkiniDetailApp
                  id={selectedId as string}
                  isRuangGtkEnabled={isRuangGtkEnabled}
                  isDesktop={isDesktop}
                />
              ) : (
                <div className="flex items-center justify-center h-full">
                  <Text variant="body" color="subdued">
                    Pilih pemberitahuan untuk melihat detail
                  </Text>
                </div>
              )}
            </main>
          </PageContainer>
        </div>
      </div>
    )
  }

  return (
    <div className="mt-14">
      <Header
        isRuangGtkEnabled={isRuangGtkEnabled}
        title={isRuangGtkEnabled ? 'Pemberitahuan' : 'Info Terkini'}
        showUserProfile={false}
      />

      <InfoTerkiniListGroup />

      {isRuangGtkV3Enabled && !isDesktop ? (
        <BottomNav />
      ) : (
        <NavigationBar isRuangGtkEnabled={isRuangGtkEnabled} />
      )}
    </div>
  )
}

export default InfoTerkini
